<div class="issue-decision-modal" role="presentation">
  <div class="issue-decision-modal__backdrop" aria-hidden="true"></div>

  <section
    #dialogPanel
    class="issue-decision-modal__panel"
    role="dialog"
    aria-modal="true"
    aria-labelledby="issue-decision-title"
    aria-describedby="issue-decision-subtitle"
  >
    <header class="issue-decision-modal__header">
      <div>
        <h2 id="issue-decision-title" class="issue-decision-modal__title">
          {{ i18n.t('issueDecision.title') }}
        </h2>
        <p id="issue-decision-subtitle" class="issue-decision-modal__subtitle">
          {{ i18n.t('issueDecision.subtitle') }}
        </p>
      </div>

      <button
        class="app-icon-button issue-decision-modal__close"
        type="button"
        [disabled]="isSubmitting()"
        [attr.aria-label]="i18n.t('common.actions.close')"
        (click)="close()"
      >
        <span class="fa-solid fa-xmark" aria-hidden="true"></span>
      </button>
    </header>

    <form class="issue-decision-modal__form" [formGroup]="form" (ngSubmit)="submit()">
      <label
        class="app-field"
        [class.app-field--invalid]="form.controls.status.invalid && form.controls.status.touched"
      >
        <span class="app-field__label">{{ i18n.t('issueDecision.fields.status') }}</span>
        <select #statusSelect formControlName="status">
          <option value="">{{ i18n.t('issueDecision.placeholders.status') }}</option>
          @for (status of statuses; track status.value) {
            <option [value]="status.value">{{ i18n.t(status.labelKey) }}</option>
          }
        </select>
        @if (form.controls.status.touched && form.controls.status.hasError('required')) {
          <span class="app-field__error"><span class="app-message__icon app-message__icon--error fa-solid fa-circle-exclamation" aria-hidden="true"></span> {{ i18n.t('issueReport.errors.required') }}</span>
        }
      </label>

      <label
        class="app-field"
        [class.app-field--invalid]="form.controls.reason.invalid && form.controls.reason.touched"
      >
        <span class="app-field__label">{{ i18n.t('issueDecision.fields.reason') }}</span>
        <textarea
          class="app-textarea"
          formControlName="reason"
          rows="4"
          [placeholder]="i18n.t('issueDecision.placeholders.reason')"
        ></textarea>
        @if (form.controls.reason.touched && form.controls.reason.hasError('required')) {
          <span class="app-field__error"><span class="app-message__icon app-message__icon--error fa-solid fa-circle-exclamation" aria-hidden="true"></span> {{ i18n.t('issueDecision.errors.reasonRequired') }}</span>
        } @else {
          <span class="issue-decision-modal__hint">{{ i18n.t('issueDecision.reasonHint') }}</span>
        }
      </label>

      @if (submitError(); as error) {
        <div class="form-message" role="alert"><span class="app-message__icon app-message__icon--error fa-solid fa-circle-exclamation" aria-hidden="true"></span> {{ error }}</div>
      }

      <footer class="issue-decision-modal__actions">
        <button
          class="secondary-button secondary-button--indigo"
          type="button"
          [disabled]="isSubmitting()"
          (click)="close()"
        >
          {{ i18n.t('common.actions.cancel') }}
        </button>
        <button class="primary-button" type="submit" [disabled]="isSubmitting()">
          {{
            isSubmitting()
              ? i18n.t('issueDecision.actions.submitting')
              : i18n.t('issueDecision.actions.submit')
          }}
        </button>
      </footer>
    </form>
  </section>
</div>
